import { Box, Button, Chip, Grid, Skeleton, Tab, Tabs, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import useFetchAdminEvaluadores from '../hooks/useFetchAdminEvaluadores'
import EvaluadoresCard from './EvaluadoresCard'
import EvaluadoresTable from './EvaluadoresTable'

const getEstadoGrupo = (p_evaluacion) => {
  if (p_evaluacion >= 100) return 'completada'
  if (p_evaluacion > 0) return 'en_progreso'
  return 'sin_iniciar'
}

const ESTADO_CONFIG = {
  sin_iniciar: { label: 'Sin iniciar', order: 0 },
  en_progreso: { label: 'En progreso', order: 1 },
  completada: { label: 'Completada', order: 2 },
}

const TabPanel = ({ children, value, index }) => (
  <Box role="tabpanel" hidden={value !== index} sx={{ pt: 2 }}>
    {value === index && children}
  </Box>
)

const AdminEvaluadores = ({ procesoId, onEvaluadorClick, onBack }) => {
  const { response, loading, error } = useFetchAdminEvaluadores({ id: procesoId })
  const [activeTab, setActiveTab] = useState(0)
  const [evaluadoresPorEstado, setEvaluadoresPorEstado] = useState({})

  useEffect(() => {
    if (response && response.length > 0) {
      const agrupados = {}
      response.forEach((evaluador) => {
        const grupo = getEstadoGrupo(evaluador.p_evaluacion || 0)
        if (!agrupados[grupo]) agrupados[grupo] = []
        agrupados[grupo].push(evaluador)
      })
      setEvaluadoresPorEstado(agrupados)
      setActiveTab(0)
    }
  }, [response])

  const activeGroups = Object.entries(evaluadoresPorEstado)
    .filter(([, evaluadores]) => evaluadores && evaluadores.length > 0)
    .sort(([a], [b]) => (ESTADO_CONFIG[a]?.order ?? 99) - (ESTADO_CONFIG[b]?.order ?? 99))

  if (error) {
    return <Typography>Error: {error}</Typography>
  }

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Button variant="contained" color="primary" onClick={onBack}>
          Volver a Evaluaciones
        </Button>
      </Box>
      {loading ? (
        <Box>
          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
            {[120, 90, 100].map((w, i) => (
              <Skeleton key={i} variant="rounded" width={w} height={36} />
            ))}
          </Box>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <Grid container spacing={2}>
              {Array.from({ length: 6 }, (_, i) => (
                <Grid
                  key={i}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    xl: 3,
                  }}
                >
                  <EvaluadoresCard loading />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <EvaluadoresTable evaluadores={[]} loading={true} onEvaluadorClick={() => {}} />
          </Box>
        </Box>
      ) : (
        <>
          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {activeGroups.map(([grupoKey, evaluadores]) => (
              <Tab
                key={grupoKey}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {ESTADO_CONFIG[grupoKey]?.label ?? grupoKey}
                    <Chip label={evaluadores.length} size="small" />
                  </Box>
                }
              />
            ))}
          </Tabs>
          {activeGroups.map(([grupoKey, evaluadores], index) => (
            <TabPanel key={grupoKey} value={activeTab} index={index}>
              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Grid container spacing={2}>
                  {evaluadores.map((evaluador) => (
                    <Grid
                      key={evaluador.usuario_web}
                      size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                      }}
                    >
                      <EvaluadoresCard evaluador={evaluador} onEvaluadorClick={onEvaluadorClick} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <EvaluadoresTable
                  evaluadores={evaluadores}
                  loading={false}
                  onEvaluadorClick={onEvaluadorClick}
                />
              </Box>
            </TabPanel>
          ))}
        </>
      )}
    </Box>
  )
}

export default AdminEvaluadores
